import useLang from 'hooks/useLang';
import useTheme from 'hooks/useTheme';
import usePaytoStore from './payment/usePaytoStore';

const usePaytoGuideline = () => {
  const { t, locate } = useLang();
  const { isHHMTTheme } = useTheme();
  const { paytoAccountAuthorising } = usePaytoStore();
  const { bankCode } = paytoAccountAuthorising || {};

  const getPaytoGuidelineUrl = (accountAgreement = null) => {
    const bankCodeValue = accountAgreement?.bankCode || bankCode;

    if (isHHMTTheme) {
      if (bankCodeValue)
        return t('link_payto_bsb_guideline_hhmt', {
          lang: locate,
          bankCode: bankCodeValue,
        });
      return t('link_payto_guideline_hhmt', {
        lang: locate,
      });
    }
    if (bankCodeValue)
      return t('link_payto_bsb_guideline_remox', {
        bankCode: bankCodeValue,
      });
    return t('link_payto_guideline_remox');
  };
  return { getPaytoGuidelineUrl };
};

export default usePaytoGuideline;
